import Carousel from "./Carousel";
import ProductCenter from "./ProductCenter";
import AboutUs from "./AboutUs";
import DevelopmentHistory from "./DevelopmentHistory/";
import NewsTrands from "./NewsTrands";
export default {
  name: "Home",
  components: {
    Carousel: Carousel,
    ProductCenter: ProductCenter,
    AboutUs: AboutUs,
    DevelopmentHistory: DevelopmentHistory,
    NewsTrands: NewsTrands
  }
};